import { getMPDataWithParams, postMPDataWithParams } from 'src/mentor/services'

/**
 * Get all products
 * @returns {Promise} API response with products list
 */
export const getAllProducts = async () => {
  try {
    const response = await getMPDataWithParams('/api/secure/cc/support/doc-side/products', {})
    return response
  } catch (error) {
    console.error('Error getting all products:', error)
    throw error
  }
}

/**
 * Get all product contexts
 * @returns {Promise} API response with products list
 */
export const getAllProductContexts = async () => {
  try {
    const response = await getMPDataWithParams('/api/secure/cc/support/doc-side/product-contexts', {})
    return response
  } catch (error) {
    console.error('Error getting all products:', error)
    throw error
  }
}

/**
 * Get MetaUserRoles by product ID
 * @param {string} productId - Product ID
 * @returns {Promise} API response with roles list
 */
export const getMetaUserRolesByProductId = async (productId) => {
  try {
    const response = await getMPDataWithParams('/api/secure/cc/support/doc-side/meta-user-roles', {
      productId: productId,
    })
    return response
  } catch (error) {
    console.error('Error getting meta user roles by product ID:', error)
    throw error
  }
}

/**
 * Search for playable external content based on roles and product
 * @param {Object} searchCriteria - { roles: string[], productId: string }
 * @returns {Promise} API response with content list
 */
export const searchPlayableExternalContent = async (searchCriteria) => {
  try {
    const response = await getMPDataWithParams(
      '/api/secure/cc/support/doc-side/playable-external-content/search',
      searchCriteria
    )
    return response
  } catch (error) {
    console.error('Error searching playable external content:', error)
    throw error
  }
}

/**
 * Get playable external content by ID
 * @param {string} id - Content ID
 * @returns {Promise} API response with content details
 */
export const getPlayableExternalContentById = async (id) => {
  try {
    const response = await getMPDataWithParams(
      `/api/secure/cc/support/doc-side/playable-external-content/${id}`,
      {}
    )
    return response
  } catch (error) {
    console.error('Error getting playable external content by ID:', error)
    throw error
  }
}

/**
 * Save playable external content (create or update)
 * @param {Object} content - Content object to save
 * @returns {Promise} API response with saved content
 */
export const savePlayableExternalContent = async (content) => {
  try {
    const response = await postMPDataWithParams(
      '/api/secure/cc/support/doc-side/playable-external-content',
      content
    )
    return response
  } catch (error) {
    console.error('Error saving playable external content:', error)
    throw error
  }
}

/**
 * Delete playable external content by ID
 * @param {string} id - Content ID to delete
 * @returns {Promise} API response
 */
export const deletePlayableExternalContent = async (id) => {
  try {
    const response = await postMPDataWithParams(
      `/api/secure/cc/support/doc-side/playable-external-content/${id}/delete`,
      {}
    )
    return response
  } catch (error) {
    console.error('Error deleting playable external content:', error)
    throw error
  }
} 
